let toastTimer: number | undefined;
let closeBound = false;

function getToast(): HTMLElement | null {
  return document.getElementById("toast");
}

function getToastText(): HTMLElement | null {
  return document.getElementById("toast-text");
}

function dismissToast(): void {
  const toast = getToast();
  if (!toast) return;
  toast.classList.remove("is-visible");
  if (toastTimer !== undefined) {
    window.clearTimeout(toastTimer);
    toastTimer = undefined;
  }
}

function bindToastDismiss(): void {
  if (closeBound) return;
  const toast = getToast();
  if (!toast) return;
  const closeButton = document.getElementById("toast-close");
  closeButton?.addEventListener("click", event => {
    event.stopPropagation();
    dismissToast();
  });
  toast.addEventListener("click", () => dismissToast());
  closeBound = true;
}

export function showToast(message: string, isError = false): void {
  const toast = getToast();
  const textEl = getToastText();
  if (!toast || !textEl) return;

  bindToastDismiss();

  textEl.textContent = message;
  toast.classList.toggle("is-success", !isError);
  toast.classList.toggle("is-error", isError);
  toast.classList.add("is-visible");

  if (toastTimer !== undefined) window.clearTimeout(toastTimer);
  toastTimer = window.setTimeout(
    () => {
      toast.classList.remove("is-visible");
      toastTimer = undefined;
    },
    isError ? 7000 : 4000,
  );
}

export function formatError(error: unknown): string {
  if (!error) return "Something went wrong.";
  if (typeof error === "string") return error;
  if (error instanceof Error && error.message) return error.message;
  if (typeof error === "object" && error !== null && "message" in error) {
    const message = (error as { message?: unknown }).message;
    if (typeof message === "string" && message.length > 0) return message;
  }
  return "Something went wrong.";
}
